import { useGetBuyerDealNumberQuery, useGetDealNumberQuery } from '@/app/api';
import { Box, IconButton, Stack, Typography } from '@mui/material';
import dayjs from 'dayjs';
import { useNavigate } from 'react-router-dom';

import ArrowLeftIcon from '@/app/assets/icons/arrow-left.svg?react';

import { Trans, useTranslation } from 'react-i18next';
import { FC } from 'react';

interface Props {
  type: 'buyer' | 'seller';
  number?: string | number;
}

export const CreateSellerRequestTitle: FC<Props> = ({ number, type }) => {
  const { t } = useTranslation('');
  const navigate = useNavigate();

  const { data: sellerData } = useGetDealNumberQuery(
    {},
    { refetchOnMountOrArgChange: true, skip: !!number || type !== 'seller' }
  );
  const { data: buyerData } = useGetBuyerDealNumberQuery(
    {},
    {
      refetchOnMountOrArgChange: true,
      skip: !!number || type !== 'buyer',
    }
  );

  const data = type === 'seller' ? sellerData : buyerData;

  const handleBack = () => {
    navigate(-1);
  };

  return (
    <Stack direction='row' spacing={1} alignItems='center'>
      <IconButton onClick={handleBack}>
        <ArrowLeftIcon />
      </IconButton>
      <Typography variant='h5'>
        <Trans
          t={t}
          i18nKey='create_deal_title'
          components={[
            <Box
              component='span'
              sx={{
                fontWeight: 500,
                opacity: 0.5,
              }}
            />,
          ]}
          values={{
            date: dayjs().format('DD.MM.YYYY'),
            number: number || data?.data.number,
          }}
        />
      </Typography>
    </Stack>
  );
};
